export default function admin ({ next, store }){
    if(store.getters.getUserRole!="Admin"){
        return next({
           name: 'dashboard'
        })
    }
   
    return next()
   }